// GENERATED FILE — do not edit by hand. Written by scripts/generate-build-info.js
// via the prebuild/prestart npm hooks. Gitignored. See scripts/generate-build-info.js.
export const BUILD_INFO = {
  sha: '3607c0b',
} as const;
